import { ENTERPRISE, FREE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
export const HighlightedProductsHeaderConfig = {
  [MARKETING]: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.marketing'
    },
    [STARTER]: {
      title: 'merchCards.starterCard.title.marketing',
      subtitle: 'merchCards.starterCard.description.marketing',
      includes: 'pricing-pages.products.marketing-hub-starter.includes',
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
    },
    [PROFESSIONAL]: {
      title: 'merchCards.professionalCard.title.marketing',
      subtitle: 'merchCards.professionalCard.description.marketing',
      includes: 'pricing-pages.products.marketing-hub-professional.includes',
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'merchCards.enterpriseCard.title.marketing',
      subtitle: 'merchCards.enterpriseCard.description.marketing',
      includes: 'pricing-pages.products.marketing-hub-enterprise.includes',
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  },
  [SALES]: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.sales'
    },
    [STARTER]: {
      title: 'merchCards.starterCard.title.sales',
      subtitle: 'merchCards.starterCard.description.sales',
      includes: `pricing-pages.products.sales-hub-starter.includes`,
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
    },
    [PROFESSIONAL]: {
      title: 'merchCards.professionalCard.title.sales',
      subtitle: 'merchCards.professionalCard.description.sales',
      includes: 'pricing-pages.products.sales-hub-professional.includes',
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'merchCards.enterpriseCard.title.sales',
      subtitle: 'merchCards.enterpriseCard.description.sales',
      includes: 'pricing-pages.products.sales-hub-enterprise.includes',
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  },
  [SERVICE]: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.service'
    },
    [STARTER]: {
      title: 'merchCards.starterCard.title.service',
      subtitle: 'merchCards.starterCard.description.service',
      includes: 'pricing-pages.products.service-hub-starter.includes',
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
    },
    [PROFESSIONAL]: {
      title: 'merchCards.professionalCard.title.service',
      subtitle: 'merchCards.professionalCard.description.service',
      includes: 'pricing-pages.products.service-hub-professional.includes',
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'merchCards.enterpriseCard.title.service',
      subtitle: 'merchCards.enterpriseCard.description.service',
      includes: 'pricing-pages.products.service-hub-enterprise.includes',
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  },
  [CMS]: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.cms'
    },
    [STARTER]: {
      title: 'merchCards.starterCard.title.cms',
      subtitle: 'merchCards.starterCard.description.cms',
      lowerTierPlus: 'pricing-pages.hubTiers.starter.includes'
    },
    [PROFESSIONAL]: {
      title: 'merchCards.professionalCard.title.cms',
      subtitle: 'merchCards.professionalCard.description.cms',
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'merchCards.enterpriseCard.title.cms',
      subtitle: 'merchCards.enterpriseCard.description.cms',
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  },
  [OPERATIONS]: {
    [FREE]: {
      title: 'merchCards.freeCard.title',
      subtitle: 'merchCards.freeCard.description.operations'
    },
    [STARTER]: {
      title: 'merchCards.starterCard.title.operations',
      subtitle: 'merchCards.starterCard.description.operations',
      lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
    },
    [PROFESSIONAL]: {
      title: 'merchCards.professionalCard.title.operations',
      subtitle: 'merchCards.professionalCard.description.operations',
      lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
    },
    [ENTERPRISE]: {
      title: 'merchCards.enterpriseCard.title.operations',
      subtitle: 'merchCards.enterpriseCard.description.operations',
      lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
    }
  }
};